import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '@/pages/HomePage/HomePage.vue';

const SCROLL_RESTORE_TIMEOUT = 1000;

function waitForScrollHeight(top: number): Promise<void> {
  return new Promise((resolve) => {
    const deadline = performance.now() + SCROLL_RESTORE_TIMEOUT;
    const check = () => {
      const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
      if (maxScroll >= top || performance.now() >= deadline) {
        resolve();
        return;
      }
      requestAnimationFrame(check);
    };
    requestAnimationFrame(check);
  });
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomePage,
      meta: { hideHeaderImage: true, }
    },
    {
      path: '/preorders',
      name: 'preorders',
      component: () => import('@/pages/Preorders/ui/PreordersPage.vue'),
    },
    {
      path: '/preorders/:param',
      name: 'preorder',
      component: () => import('@/pages/Preorder/ui/PreorderPage.vue'),
    },
    {
      path: '/product/:id',
      name: 'product',
      component: () => import('@/pages/Product/ui/ProductPage.vue'),
      props: true
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('@/pages/Search/ui/SearchPage.vue'),
    },
    {
      path: '/fandom',
      name: 'fandom',
      component: () => import('@/pages/Fandom/ui/FandomPage.vue'),
    },
    {
      path: '/cart',
      name: 'cart',
      component: () => import('@/pages/Cart/ui/Cart.vue'),
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import('@/pages/PrivacyPolicy/ui/PrivacyPolicy.vue'),
    },
    {
      path: '/public-offer',
      name: 'public-offer',
      component: () => import('@/pages/PublicOffer/ui/PublicOffer.vue'),
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('@/pages/Orders/ui/OrdersPage.vue'),
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('@/pages/FAQ/FAQ.vue'),
    },
    {
      path: '/redirect/:type',
      name: 'redirect',
      component: () => import('@/pages/Redirect/RedirectWaiting.vue'),
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.path === from.path) {
      return false
    }
    if (!savedPosition) {
      return { top: 0 }
    }
    return waitForScrollHeight(savedPosition.top).then(() => savedPosition)
  }
});

router.beforeEach((to, from, next) => {
  if (document.body.style.overflow == 'hidden') {
    console.log("Removing overflow deleting...");
    document.body.style.overflow = '';
  }
  next()
})

export default router;
